export enum PrototypeMessageType {
  TOKEN_RECEIVED = 'TOKEN_RECEIVED',
  TOKEN_TIMEOUT = 'TOKEN_TIMEOUT',
  AUTH_TOKEN = 'AUTH_TOKEN',
  TOKEN_EXCHANGE_COMPLETE = 'TOKEN_EXCHANGE_COMPLETE',
}
